document.addEventListener('DOMContentLoaded', function () {
	if(document.querySelectorAll('.js-choice').length > 0) {
		const choices = new Choices('.js-choice', {
			allowHTML: false,
			duplicateItemsAllowed: false,
			searchEnabled: false,
			loadingText: 'Načítání...',
			noResultsText: 'Žádné výsledky',
			noChoicesText: 'Žádné volby k výběru',
			itemSelectText: 'Pro výběr kliněte',
			uniqueItemText: 'Pouze unikátní hodnoty mohou být přidány',
			customAddItemText: 'Pouze hodnoty odpovídající specifickým podmínkám mohou být přidány',
		});
	}
});